import { Message } from "../../types/types";
import { useRef, useState } from "react";
import styles from "./PromotionalMessageItem.module.scss";
import { PromotionalCountdownTimer } from "./PromotionalCountdownTimer/PromotionalCountdownTimer";
import cx from "classnames";
import { SaleTagIcon } from "../__shared__/SaleTagIcon/SaleTagIcon";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { InfoOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";

type Props = {
  message: Message;
  countdownTimerAvailabileToOrder: boolean;
  isBlackOverride: boolean;
  isPricePromise: boolean;
};

export const PromotionalMessageItem = ({
  message,
  countdownTimerAvailabileToOrder,
  isBlackOverride = false,
  isPricePromise = false,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoButtonRef = useRef<HTMLButtonElement>(null);

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
    infoButtonRef.current?.focus();
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);

  const messageTitle = () => {
    const pricePromiseMessageType = "Price match price established";
    const pricePromiseManualOverrideRegex = /match/i;
    const promoMessageTitle = message.title;
    const lowerCaseFirstLetter =
      promoMessageTitle.charAt(0).toLowerCase() + promoMessageTitle.slice(1);

    if (isPricePromise && message.promotionType === pricePromiseMessageType) {
      const isManualOverride = promoMessageTitle.match(
        pricePromiseManualOverrideRegex,
      );
      if (!isManualOverride) return `Price matched: ${lowerCaseFirstLetter}`;
    }
    return promoMessageTitle;
  };

  return (
    <>
      <div className={styles.promoMessageContainer}>
        <div className={styles.messageContainer}>
          {message.title !== "Outlet" && (
            <SaleTagIcon type="small" isBlackOverride={isBlackOverride} />
          )}
          <p
            className={cx(
              styles.message,
              isBlackOverride && styles["blackOverride"],
            )}
          >
            {messageTitle()}
          </p>
          {message.description ? (
            <IconButton
              IconComponent={InfoOutlined}
              ariaLabel={`${message.title} information`}
              data-testid="product:delivery-service:tooltip:button:expand"
              className={styles.promoToolTip}
              ref={infoButtonRef}
              onClick={handleTooltipExpandClick}
              variant="clear-light"
            />
          ) : null}
        </div>
        <PromotionalCountdownTimer
          message={message.title}
          availableToOrder={countdownTimerAvailabileToOrder}
        />
      </div>
      <div
        data-testid="product:promotional-message:tooltip"
        className={showInfo ? styles.infoBlock : styles.infoBlockHide}
      >
        <IconButton
          IconComponent={CloseOutlined}
          ariaLabel={"Collapse tooltip"}
          data-testid="product:promotional-message:tooltip:button:collapse"
          className={styles.closeButton}
          onClick={handleTooltipCollapseClick}
          variant="clear-light"
        />
        <div aria-live="polite" className={styles.tip}>
          <div dangerouslySetInnerHTML={{ __html: `${message.description}` }} />
        </div>
      </div>
    </>
  );
};
